<template>
  <div id="app" class="zj-app">
    <!-- 预警弹窗提醒 -->
    <!-- <ElaryWarningBox :warningId.sync="warningId"></ElaryWarningBox> -->
    <!--<zj-login v-if="!isLogin" @login="onLogin" />-->
    <component :is="ui.login" v-if="!isLogin" @login="onLogin" />
    <zj-startup
      v-else-if="isLogin && !isInit"
      :percent="startup.percent"
      :msg="startup.msg"
    />
    <div class="zj-app-box" v-else-if="isLogin && isInit && style == 1"  :style="{backgroundImage:'url('+pageBg+')'}">
      <zj-dynamic-container
        class="zj-app-header"
        v-if="THM('header.visiable', true)"
        :view="ui.headerHegu"
        :viewData="THM('header.style', {})"
      />
      <div class="zj-app-body zj-app-body-hegu">
        <zj-dynamic-container
          class="zj-app-sidemenu zj-app-sidemenu-left"
          v-if="isSideMenuVisiable"
          :view="ui.sidemenu"
        />
        <zj-dynamic-container
          class="zj-app-workspace"
          :class="{ 'zj-app-bg': isShowbgImg }"
          :view="ui.workspace"
        />
      </div>
      <zj-dynamic-container
        class="zj-app-footer"
        v-if="THM('footer.visiable', true)"
        :view="ui.footer"
      />
    </div>
    <div class="zj-app-box" v-else-if="isLogin && isInit">
      <zj-dynamic-container
        class="zj-app-header"
        v-if="THM('header.visiable', true)"
        :view="ui.header"
        :viewData="THM('header.style', {})"
        :menu="menu1"
      />
      <div class="zj-app-body">
        <zj-dynamic-container
          class="zj-app-sidemenu zj-app-sidemenu-left"
          v-if="isSideMenuVisiable"
          :view="ui.sidemenu"
        />
        <zj-dynamic-container
          class="zj-app-workspace"
          :class="{ 'zj-app-bg': isShowbgImg }"
          :view="ui.workspace"
        />
      </div>
      <zj-dynamic-container
        class="zj-app-footer"
        v-if="THM('footer.visiable', true)"
        :view="ui.footer"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "../utils";
// import ZJApis from "../api";
import { getUserInfo, getRouters } from "@/api/system/permission/login";
// import ComponentUserOrgControlVue from '../../../bei0717/clientweb/src/plugins/emergency/src/views/src/EmergencyOperations/Components/Component-UserOrgControl.vue';
// import ElaryWarningBox from "../plugins/serviceAlarm/src/views/src/elaryWarning/ElaryWarningBox"
export default {
  name: "ZjApp",
  componentName: "ZjApp",
  components: {
    // ElaryWarningBox
  },
  data() {
    return {
      isInit: false,
      ui: {
        login: "ZjLogin",
        header: "ZjHeader",
        sidemenu: "ZjSideMenu",
        footer: "ZjFooter",
        workspace: "ZjWorkSpace",
        headerHegu: "ZjHeaderHegu"
      },
      startup: {
        percent: 0,
        msg: "启动中...",
      },
      warningId: ""
    };
  },
  computed: {
    currentNavMenu() {
      return this.menu.currentNavMenu;
    },
    currentMenu() {
      return this.menu.currentMenu;
    },
    isSideMenuVisiable() {
      return (
        this.THM("sidemenu.visiable", true) &&
        this.currentNavMenu &&
        this.currentNavMenu.MenuInfos &&
        this.currentNavMenu.MenuInfos.length
      );
    },
    ...mapGetters(["isShowbgImg"]),
    style() {
      return this.config.app.style || '0';
    },
    pageBg(){
      return  '/theme/default/img/common/' + this.config.app.project + '/page-bg.png'
    }, 
  },
  created() {
    let loginComponent = "";
    if (
      !utils.getQueryString("token") &&
      utils.getQueryString("accessToken") != undefined &&
      utils.getQueryString("accessToken") != "" &&
      utils.getQueryString("accessToken") != null
    ) {
      loginComponent = "ZjNoLoginNew";
    } else if (
      !utils.getQueryString("token") &&
      utils.getQueryString("userName") != undefined &&
      utils.getQueryString("userName") != "" &&
      utils.getQueryString("userName") != null
    ) {
      loginComponent = "ZjNoLogin";
    } else {
      console.log("ppppppppppppppppp++++++++++++++++++++++")
      console.log(utils.getQueryString("accessToken"))
      loginComponent = this.CNF("ui.loginComponent", null);
    }

    if (loginComponent) {
      this.ui.login = loginComponent;
    }

    // var mainUrl="http://biaozhunhua.zjht100.com/tsscdataview";
    // window.location.href = mainUrl;
    this.$on("nav-click", this.onNavClick);
    this.$on("sidemenu-select", this.onMenuSelect);
    this.$on("sidemenu-open", this.onMenuOpen);
    this.$on("sidemenu-close", this.onMenuClose);
    this.$on("select-nav", this.selectNavMenu);
    this.$on("select-sidemenu", this.selectSideMenu);
    if (this.isLogin) {
      if (this.CNF("app.isBiaoZhunHua")) {
        this.initBiaoZhunHua();
      } else {
        this.init();
      }
    }
    if (document) {
      document.title = this.THM("header.title.text", this.CNF("app.name"));
    }

    this.isNotifyClosed = false;
    this.$notify.on("close", () => {
      if (!this.isNotifyClosed) {
        this.isNotifyClosed = true;
        console.log("消息服务已断开");
        // this.$message({
        //   message: "消息服务已断开",
        //   type: "error",
        // });
      }
    });
    this.$notify.on("open", () => {
      if (this.isNotifyClosed) {
        this.isNotifyClosed = false;
        console.log("消息服务已连接");
        // this.$message({
        //   message: "消息服务已连接",
        //   type: "success",
        // });
      }
    });
  },
  mounted() {
    // 预警弹窗提醒
    this.$notify.subscript(
      "msgkey_business_alarm", //订阅消息的key
      (x) => this.onRecv(x)
    );

    console.debug("Subscript: msgkey_business_alarm");
  },
  methods: {
    onRecv(x) {
      var content = x.firstBlock().text;
      console.log("报警123", x);
      console.log("报警fddddsssddss", content);
      if (content) {
        this.warningId = content;
      }
    },
    onNavClick(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onNavClick(m);
    },

    onMenuOpen(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuOpen(m);
    },

    onMenuClose(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuClose(m);
    },

    onMenuSelect(menuId) {
      const m = this.menu.findMenuByMenuId(menuId);
      this.$router.onMenuSelect(m);
    },

    // 登录成功
    onLogin(user) {
      this.$emit("login", user);
      this.$zjapp.emit("login", {
        user: user,
      });
      if (this.CNF("app.isBiaoZhunHua")) {
        this.initBiaoZhunHua();
      } else {
        this.init();
      }
    },

    selectNavMenu(menu) {
      console.log("selectNavMenu", menu);
      this.menu.currentNavMenu = menu;
    },

    selectSideMenu(menu) {
      console.log("selectSideMenu", menu);
      this.menu.currentMenu = menu;
    },
    //标准化方式登录初始化
    initBiaoZhunHua() {
      let user = this.user.userInfo;
      this.startup.percent = 50;
      this.startup.msg = "初始化...";
      let leftArr = [];
      //不改变原数组
      const leftMenus = JSON.parse(JSON.stringify(user.left));
      for (let i in leftMenus) {
        leftArr.push(leftMenus[i]); //属性
        //arr.push(obj[i]); //值
      }
      let leftMenuArr = [];
      for (let i in leftArr) {
        if (leftArr[i].length > 0) {
          leftMenuArr = leftMenuArr.concat(utils.flattenArray(leftArr[i]));
        }
      }
      let menuArr = leftMenuArr.concat(user.top || []);

      const subMenuArr = menuArr.map((item) => {
        return {
          MenuId: item.code,
          ParentMenuId: item.parentCode || this.CNF("app.menu_code"),
          MenuUrl: item.url,
          MenuCode: item.code,
          Id: item.id,
          MenuIndex: item.orderNum,
          MenuName: item.name,
          MenuImg: item.image,
          Description: item.description,
          CreateTime: item.createdate,
          ModifyTime: item.modifydate,
        };
      });

      const topArr = [
        {
          MenuId: this.CNF("app.menu_code"),
          ParentMenuId: "",
          MenuUrl: "",
          MenuCode: this.CNF("app.menu_code"),
          Id: 0,
          MenuIndex: 0,
          MenuName: this.CNF("app.name"),
          MenuImg: "",
          Description: "",
          CreateTime: "",
          ModifyTime: "",
        },
      ];
      const menus = this.convertToTreeNodes(topArr.concat(subMenuArr));
      this.menu.setMenu({ ...menus[0] } || {}, this.config);

      const userArr = [user.user];
      const users = userArr.map((item) => {
        return {
          Id: item.id,
          UserId: item.code,
          UserName: item.userName,
          Phone: item.phone,
          Description: item.description,
          CreateTime: item.createdate,
          Creater: item.creater,
          ModifyTime: item.modifydate,
          Modifier: item.modefier,
          OrgId: item.organizationCode,
        };
      });

      const departmentArr = user.organization;
      const departs = departmentArr.map((item) => {
        return {
          Id: item.id,
          OrgId: item.code,
          OrgName: item.name,
          Description: item.description,
          CreateTime: item.createdate,
          Creater: item.creater,
          ModifyTime: item.modifydate,
          Modifier: item.modefier,
        };
      });

      let u = { ...users[0] } || {};
      u.Roles = user.user.roleList || [];
      u.Role = [];
      u.Departments = departs || [];
      u.userInfo = this.user.userInfo;
      this.user.setUser(u);
      this.initRouter();

      this.startup.percent = 100;
      this.startup.msg = "启动中...";
      this.$router.firstSetup(this);
      this.isInit = true;
      this.$zjapp.emit("started", {
        user: this.user,
        menu: this.menu,
        config: this.config,
      });
    },
    //转换数据适应本系统数据格式
    jsonToArray(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.jsonToArray(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },

    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["MenuId"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let pid = cur.ParentMenuId ? cur.ParentMenuId : 0;
        let parent = formatObj[pid];
        if (parent) {
          parent.MenuInfos
            ? parent.MenuInfos.push(cur)
            : (parent.MenuInfos = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
      return formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },

    // 初始化
    init() {
      return utils
        .waitAll([
          () => this.fetchUserDetails(),
          (r) => this.menu.setMenu(r[0].menu, this.config),
          () => this.initRouter(),
        ])
        .then((r) => {
          console.log(r, 456);
          this.startup.percent = 100;
          this.startup.msg = "启动中...";
          this.$router.firstSetup(this);
          this.isInit = true;
          console.log(this.user, this.menu, this.config);
          this.$zjapp.emit("started", {
            user: this.user,
            menu: this.menu,
            config: this.config,
          });
        });
    },

    // 获取用户详细资料、用户菜单、用户角色、用户部门
    fetchUserDetails() {
      let user = this.user;
      let username = user.LoginName;
      return utils.waitAll(
        [
          // 用户信息
          () => {
            return getUserInfo(username);
          },
          // 用户菜单
          () => {
            return getRouters();
          },
          //
          // // 用户资料 ---0
          // () => {
          //   this.startup.percent = 0;
          //   this.startup.msg = "获取用户资料...";
          //   return new ZJApis.UserApi().GetItemById({
          //     username: userId,
          //   });
          // },
          // // 用户角色 ---1
          // () => {
          //   this.startup.percent = 25;
          //   this.startup.msg = "获取用户角色...";
          //   return new ZJApis.UserRoleApi().GetByUserId({
          //     UserId: userId,
          //   });
          // },
          // // 角色名称 ---2
          // (r) => {
          //   let arr = [];
          //   let api = new ZJApis.RoleApi();
          //   let roles = r[1].data.Data || [];
          //   for (let i = 0; i < roles.length; i++) {
          //     arr.push(
          //       api.GetItemById({
          //         RoleId: roles[i].RoleId,
          //       })
          //     );
          //   }
          //   let filter = (d) =>
          //     utils.each(d, (v, i) => (roles[i].RoleName = v.RoleName));
          //   return utils.waitAll(arr, filter);
          // },

          // // 用户菜单 ---3
          // () => {
          //   this.startup.percent = 50;
          //   this.startup.msg = "获取用户菜单...";
          //   return new ZJApis.UserApi().GetUserAuth({
          //     LoginName: user.LoginName,
          //     MenuCode: this.CNF("app.menu_code"),
          //     ProductCode: this.CNF("app.product_code"),
          //   });
          // },
          // // 用户部门 ---4
          // () => {
          //   this.startup.percent = 60;
          //   this.startup.msg = "获取用户部门...";
          //   return new ZJApis.OrgUserApi().FindUserCompany({
          //     UserId: userId,
          //   });
          // },
        ],
        (r) => {
          console.log(r,"================>>>>>>>")
          let u = r[0].data.sysUser || {}; //用户信息
          u.Roles = r[0].data.roles || []; //角色
          // u.Role = r[2] || [];
          // u.Departments = r[4].data.Data || [];
          if (typeof u.password !== "undefined") {
            delete u.password;
          }
          let homeLink = r[1].data[0].homeLink;
          console.log("homeLink")
          console.log(homeLink)
          this.theme.header.title.webUrl = homeLink;
          // 提取url最后/后的内容
          // function getUrlCode(url){
          //   let index = url.lastIndexOf("/");
          //   return url.slice(index+1);
          // };
          // menu处理
          const mapTree = (obj) => {
            const haveChildren =
              Array.isArray(obj.children) && obj.children.length > 0;
            return {
              MenuName: obj.meta.title,
              MenuUrl: obj.path,
              MenuId: obj.menuId,
              MenuCode: obj.component,
              MenuInfos: haveChildren
                ? obj.children.map((i) => mapTree(i))
                : undefined,
            };
          };
          let menuArr = r[1].data.map((obj) => mapTree(obj));

          if (menuArr.length == 0) {
            this.startup.msg = "无菜单权限";
            location.href = "/";
            window.ZJApp.ZJUser.prototype.logout();
            return;
          }
          const getMenuCode = (menuArr) => {
            let MenuCode = ''
            if (menuArr[0].MenuInfos && menuArr[0].MenuInfos.length) {
              MenuCode = getMenuCode(menuArr[0].MenuInfos)
            } else {
              MenuCode = menuArr[0].MenuCode
            }
            return MenuCode
          }
          let menuCode = menuArr[0].MenuCode
          if(menuCode && (utils.startsWith(menuCode.toLowerCase(), 'http://') || utils.startsWith(menuCode.toLowerCase(), 'https://'))){
            menuArr[0].MenuCode = getMenuCode(menuArr)
          }
          const rv = {
            user: u,
            menu: menuArr[0] || {}, //菜单
          };
          this.user.setUser(rv.user);
          this.startup.percent = 75;
          return rv;
        }
      );
    },
    initRouter() {
      this.startup.msg = "解析菜单配置...";
      return this.$router.loadUserMenus(this.user, this.menu, this.config);
    },
  },
};
</script>